// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"625":"common/components/BanIPModal","648":"common/components/UnbanIPModal"}[chunkId] + ".js";
};